export const ACCOUNT_TYPE_IDS = Object.freeze({
  INDIVIDUAL: 2,
  CORPORATE: 5,
});
